import styled from "styled-components";

export const Img = styled.img<{ $useShadow?: boolean; $useRadius?: boolean }>`
  max-width: 1440px;
  height: auto;
  ${({ $useShadow }) => $useShadow && "box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);"}
  ${({ $useRadius }) => $useRadius && "border-radius: 8px;"}
`;
